import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import { updateSeasonClassSuccess, navigateWizard } from '../actions';
import SeasonClassesAPI from '../api/SeasonClassesAPI';
import { PERSIST_SEASON_CLASS } from '../constants/actionTypes';
import { UPDATE_SEASON_CLASS_DATA } from '../constants/heapEvents';
import { track } from '../lib/heapHelpers';
import { buildServerSelector, accessTokenSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* seasonClassUpdateWatcher() {
  yield takeLatest(PERSIST_SEASON_CLASS, seasonClassUpdateWorker);
}

function* seasonClassUpdateWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);
    const builder = yield select(buildServerSelector);
    const { classId, id: applicationId, customerGuid } = builder;
    let seasonClassPayload;

    if (classId) {
      seasonClassPayload = yield call(SeasonClassesAPI.updateSeasonClass, builder, accessToken);
      yield put(updateSeasonClassSuccess({ response: seasonClassPayload }));
      // yield delay(process.env.REACT_APP_SEND_HALT_TIME);
      yield put(navigateWizard({ dir: 'fwd' }));
      yield call(track, UPDATE_SEASON_CLASS_DATA, {
        'Application GUID': applicationId,
        'Customer GUID': customerGuid,
      });
    }
  } catch (error) {
    // TODO: We probably need to update the local ui and server state to mark the course as inReview
    yield fork(manageAPIError, { ...error, action });
  }
}

export { seasonClassUpdateWorker };
export default seasonClassUpdateWatcher;
